import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";



// no layouts views
import { IndexComponent } from "./views/index/index.component";
import { SucessComponent } from "./sucess/sucess.component";


const routes: Routes = [
  // admin views

  // auth views
  
  { path: "", component: IndexComponent },
  { path:"sucess",component:SucessComponent},
  { path: "**", redirectTo: "", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
